//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Builder.js";
import "../no/SelectCoordinateSystem.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"ChildCsys",0,"SelectCoordinateSystem",0],[0,"LayoutType",1,0],[0,"LinearSpacing",1,0],[0,"LinearVector",1,"Direction",0],[0,"NumberOfInstances",1,0],[1,"ParentCsys",0,"SelectCoordinateSystem",0],[1,"PitchAngle",0,"Expression",0],[1,"PitchDistance",0,"Expression",0],[0,"RotationPoint",1,"Point",0],[0,"RotationSpacing",1,0],[0,"RotationVector",1,"Direction",0],[1,"SpanAngle",0,"Expression",0],[1,"SpanDistance",0,"Expression",0],[1,"Submechanism",0,"Assemblies.SelectComponent",0]],[],[]];
SPLM.Motion.SubmechanismPatternBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SubmechanismPatternBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.SubmechanismPatternBuilder.Layout = Object.freeze({
    "Circular" : "Circular", "Linear" : "Linear"});

SPLM.Motion.SubmechanismPatternBuilder.Spacing = Object.freeze({
    "CountAndPitch" : "CountAndPitch", "CountAndSpan" : "CountAndSpan"});

export default SPLM;